import * as React from 'react'

import { Box, Link, Section, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useFetchCustomTimeRangeCategories } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'

import List from './List'
import NewCategoryModal from './Modals/NewCategoryModal'

interface Props {
  settingId: number
}

const Categories = ({ settingId }: Props) => {
  const [openModal, setOpenModal] = React.useState(false)
  const { navigation } = useNavigation()

  const { categories } = useFetchCustomTimeRangeCategories(settingId)

  return (
    <>
      <Section
        illustration="add-tag"
        title={i18n.t('time_tracking.settings.time_blocks.worked_time_categories.title')}
        description={i18n.t(
          'time_tracking.settings.time_blocks.worked_time_categories.description'
        )}
        action={{
          onClick: () => {
            track(trackingEvents.timeTracking.newCategoryPressed)
            setOpenModal(true)
          },
          label: i18n.t('time_tracking.settings.time_blocks.worked_time_categories.button'),
        }}
      >
        <Box gap="s32">
          <List customTimeRangeCategories={categories} settingId={settingId} />
          <Box gap="s2">
            <Text size="100">
              {i18n.t(
                'time_tracking.settings.time_blocks.worked_time_categories.time_settings_prompt'
              )}
            </Text>
            <Link.Router to={navigation.settings.time_categories_settings.fullPath()}>
              {i18n.t(
                'time_tracking.settings.time_blocks.worked_time_categories.time_settings_prompt_link'
              )}
            </Link.Router>
          </Box>
        </Box>
        {openModal && <NewCategoryModal setModalOpen={setOpenModal} settingId={settingId} />}
      </Section>
    </>
  )
}

export default Categories
